import { massCampaignStatusColor } from '@/utils';

export const statusColor = massCampaignStatusColor;

export const initialFormState = () => ({
  name: '',
  tenantIds: [],
  uploads: [],
});

export const newUploadCard = () => ({
  localId: `card-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  uploading: false,
  uploadError: null,
  fileName: null,
  fileId: null,
  publicUrl: null,
  sheets: [],
  sheetIndex: 0,
  nameColumn: '',
  phoneColumn: '',
  emailColumn: '',
  groupName: '',
  colorTag: '#0491FF',
  tenantIds: [],
});

export function humanStatus(status) {
  const map = {
    validated: 'Pronta',
    queued: 'Na fila',
    running: 'Em andamento',
    completed: 'Concluída',
    completed_with_errors: 'Concluída com falhas',
    failed: 'Falhou',
    canceled: 'Cancelada',
    success: 'Sucesso',
    skipped: 'Ignorada',
  };
  return map[status] || status || '-';
}

export function shortError(message) {
  if (!message) return '';
  const max = 160;
  const trimmed = `${message}`.replace(/\s+/g, ' ').trim();
  return trimmed.length > max ? `${trimmed.slice(0, max)}...` : trimmed;
}

export function pendingItemsCount(batch) {
  if (!batch || !Array.isArray(batch.items)) return 0;
  return batch.items.filter((item) => ['validated', 'queued', 'running'].includes(item.status)).length;
}

export function parseTenantNameFromFqdn(fqdn) {
  if (!fqdn || typeof fqdn !== 'string') return null;
  const parts = fqdn.split('.');
  return parts[0] || null;
}
